import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';
import mavonEditor from 'mavon-editor';
import request from '@/utils/request'
import axios from "axios";
// import Router from 'vue-router'
// import router from './router'
// import './utils/rem.js'

Vue.config.productionTip = false
/**
 * @var requireComponents -- requireComponents保存每个文件的相对路径的集合,可通过keys()返回
 * @function requireComponents -- 也是个方法,传入keys()枚举出来的路径可返回组件实例
 */
const requireComponents = require.context('@/components/word/content', true);
// , /\.vue/
// 打印结果
// requireComponents: ƒ webpackContext(req) {
//   return __webpack_require__(webpackContextResolve(req));
// }
//
axios.defaults.baseURL = '/api'
Vue.prototype.$axios = axios
Vue.config.productionTip = false
// Vue.use(ElementUI, {size: "small"});
Vue.prototype.request = request
Vue.use(mavonEditor)



// 遍历出每个组件的路径
requireComponents.keys().forEach(fileName => {
  // 组件实例
  const reqCom = requireComponents(fileName)
  // 截取路径作为组件名
  const reqComName = fileName.split('/')[1]
  // 组件挂载
  Vue.component(reqComName, reqCom.default || reqCom)
})


Vue.use(ElementUI);
new Vue({
  el:'#app',
  store,
  render: h => h(App),
}).$mount('#app')
